export type FeedbackEntryPoint = "thumbs_down" | "feedback";
export type FeedbackReasonCode =
  | "helpful_and_clear"
  | "saved_me_time"
  | "sharing_context"
  | "have_a_suggestion"
  | "did_not_answer_question"
  | "answer_seems_incorrect"
  | "too_vague_or_incomplete"
  | "outdated_information"
  | "other";

export interface FeedbackOption {
  code: FeedbackReasonCode;
  label: string;
  detailPrompt: string;
}

const THUMBS_DOWN_OPTIONS: FeedbackOption[] = [
  {
    code: "did_not_answer_question",
    label: "Didn't answer my question",
    detailPrompt: "What would a more useful answer have looked like?",
  },
  {
    code: "answer_seems_incorrect",
    label: "Answer was incorrect",
    detailPrompt: "What would the right answer have looked like?",
  },
  {
    code: "too_vague_or_incomplete",
    label: "Too vague or incomplete",
    detailPrompt: "What would a clearer answer have looked like?",
  },
  {
    code: "outdated_information",
    label: "Outdated information",
    detailPrompt: "What's the correct information, and where is it from?",
  },
  {
    code: "other",
    label: "Other",
    detailPrompt: "Tell us more about why this response missed the mark.",
  },
];

const FEEDBACK_OPTIONS: FeedbackOption[] = [
  {
    code: "helpful_and_clear",
    label: "Helpful or clear",
    detailPrompt: "What was helpful or clear about this response?",
  },
  {
    code: "saved_me_time",
    label: "Saved me time",
    detailPrompt: "Glad to hear it! What part of the response saved you the most time?",
  },
  {
    code: "sharing_context",
    label: "I want to add some context",
    detailPrompt: "What context would help us understand your situation better?",
  },
  {
    code: "have_a_suggestion",
    label: "I have a suggestion for Ordinal",
    detailPrompt: "What would you change or add to make this more useful?",
  },
  {
    code: "did_not_answer_question",
    label: "Didn't answer my question",
    detailPrompt: "What would a more useful answer have looked like?",
  },
  {
    code: "answer_seems_incorrect",
    label: "Answer was incorrect",
    detailPrompt: "What would the right answer have looked like?",
  },
  {
    code: "too_vague_or_incomplete",
    label: "Too vague or incomplete",
    detailPrompt: "What would a clearer answer have looked like?",
  },
  {
    code: "outdated_information",
    label: "Outdated information",
    detailPrompt: "What's the correct information, and where is it from?",
  },
  {
    code: "other",
    label: "Other",
    detailPrompt: "Tell us more about your feedback.",
  },
];

const OPTIONS_BY_ENTRY_POINT: Record<FeedbackEntryPoint, FeedbackOption[]> = {
  thumbs_down: THUMBS_DOWN_OPTIONS,
  feedback: FEEDBACK_OPTIONS,
};

export function getFeedbackOptions(entryPoint: FeedbackEntryPoint): FeedbackOption[] {
  return OPTIONS_BY_ENTRY_POINT[entryPoint];
}

export function getFeedbackOption(
  entryPoint: FeedbackEntryPoint,
  reasonCode: FeedbackReasonCode,
): FeedbackOption | undefined {
  return getFeedbackOptions(entryPoint).find((option) => option.code === reasonCode);
}
